import {
  AppointmentType,
  CalendarType,
  CreateCalendarConfigurationDto,
  MiniCalendarType,
  ResourceDto,
  RoundingType,
} from '@lmt/shared-types';
import { UseFormReturn } from 'react-hook-form/dist/types';

export interface CalendarConfigurationFormComponentProps {
  formMethods: UseFormReturn<CalendarConfigurationFormData>;
}

export interface CalendarTypeDictionary {
  key: number;
  value: string;
}

export interface MiniCalendarTypeDictionary {
  key: number;
  value: string;
}

export interface TipsProps {
  isShowingTips: boolean;
  showTip: () => void;
  hideTip: () => void;
}

export interface ResourcesProps {
  places: ResourceDto[];
  specialConditions: ResourceDto[];
  doctors: ResourceDto[];
}

export type CalendarConfigurationFormData = Omit<
  CreateCalendarConfigurationDto,
  'defaultVisitTypeId'
> & {
  defaultVisitTypeId: number | null;
};

export const defaultCalendarConfigurationData: CalendarConfigurationFormData = {
  name: '',
  isShared: false,
  shownEventType: AppointmentType.AllEvents,
  defaultVisitTypeId: null,
  timeSlotSearchTimeStepInMinutes: 30,
  visitStartTimeInSeconds: 32400, // 9:00 AM
  calendarType: CalendarType.Week,
  weekDays: [],
  startOfDayInSecondsSinceMidnight: 32400, // 9:00 AM
  endOfDayInSecondsSinceMidnight: 68400, // 7:00 PM
  isResourceViewCalendar: false,
  roundingType: RoundingType.None,
  isMultiDayVisitRounding: false,
  isFilterDisplayed: true,
  hasFilterByVisitTypes: true,
  visitTypes: [],
  hasFilterByPlaces: true,
  places: [],
  hasFilterBySpecialConditions: true,
  specialConditions: [],
  hasFilterBySubtenants: true,
  hasFilterByDoctors: true,
  subtenants: [],
  doctors: [],
  hasFilterByTags: true,
  tags: [],
  hasFilterByVisitStatuses: true,
  visitStatuses: [],
  isShowingPatients: true,
  isShowingWaitingList: false,
  miniCalendarType: MiniCalendarType.None,
  isShowingRoomOccupancy: true,
  isShowingSelectedRoomOccupancy: false,
  showAbsences: true,
};
